// Display-time muscle/equipment/body-part translation helpers.
// Data source: copied at prebuild from backend/data/muscle_translations.json
// (see frontend/scripts/sync-translations.js).
import data from "../i18n/shared/muscle_translations.json";

export const MUSCLES = data.muscles || {};
export const EQUIPMENT = data.equipment || {};
export const BODY_PARTS = data.body_parts || {};

function lookup(table, raw, lang) {
  if (raw === null || raw === undefined) return "";
  const key = String(raw).trim().toLowerCase();
  const entry = table[key];
  if (!entry) return raw;
  return entry[lang] || entry.en || raw;
}

export function translateMuscle(raw, lang = "en") {
  return lookup(MUSCLES, raw, lang);
}

export function translateEquipment(raw, lang = "en") {
  return lookup(EQUIPMENT, raw, lang);
}

export function translateBodyPart(raw, lang = "en") {
  return lookup(BODY_PARTS, raw, lang);
}

export function translateMuscleList(rawList, lang = "en") {
  if (!Array.isArray(rawList)) return [];
  return rawList.map((m) => translateMuscle(m, lang));
}
